var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeatureManageFill = function SvgFeatureManageFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "var(--primary-color)",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280-280v-80h200q-14-17-22.5-37T444-440H200v-80h244q5-23 13.5-43t22.5-37H280v-80h360q83 0 141.5 58.5T840-480t-58.5 141.5T640-280zm-160 0v-80h120v80z"
  })));
};
export default SvgFeatureManageFill;